"use strict";

import React from "react";
import Dialog from "./../Dialog";
import Button from "./../Button";
import lang from "./../../lang";

export default class ConfirmDialog extends React.Component {
		
	render() {
		return (
			<Dialog className="ConfirmDialog" shown={this.props.shown}>
				<div>
					<label>{this.props.text}</label>
				</div>
				<footer>
					<Button onClick={() => this.props.onCancel()} className={this.props.cancelable ? "" : "Hidden"}>{lang.CANCEL}</Button>
					<Button onClick={() => this.props.onDiscard()}>{lang.NO}</Button>
					<Button onClick={() => this.props.onConfirm()} className="Red">{lang.YES}</Button>
				</footer>
			</Dialog>
		);
	}
	
	static open(props) {
		const dialog = Dialog.open(this, {
			text: props.text || "",
			cancelable: props.cancelable || false,
			onCancel: () => {
				dialog.close();
				if (props.onCancel) props.onCancel();
			},
			onDiscard: () => {
				dialog.close();
				if (props.onDiscard) props.onDiscard();
			},
			onConfirm: () => {
				dialog.close();
				if (props.onConfirm) props.onConfirm();
			}
		});
	}
	
}

ConfirmDialog.propTypes = {
	shown:		React.PropTypes.bool,
	text:		React.PropTypes.string,
	cancelable:	React.PropTypes.bool,
	onConfirm:	React.PropTypes.func,
	onDiscard:	React.PropTypes.func,
	onCancel:	React.PropTypes.func
};

ConfirmDialog.defaultProps = {
	shown:		false,
	text:		"",
	cancelable:	false,
	onConfirm:	() => {},
	onDiscard:	() => {},
	onCancel:	() => {}
};


// WEBPACK FOOTER //
// ./~/vwa/components/ConfirmDialog/ConfirmDialog.js